function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M140.469 149.961c-3.459.055-3.397.016-7.067.016l-.015.007H85.552c-21.993 0-43.97 0-65.948.016-3.413 0-6.297-1.087-8.474-3.8-1.64-2.041-2.037-4.457-2.037-7.006.016-19.408.016-38.824.016-58.231v-1.736L9 71.008V54.986l.109-8.218c0-.602-.016-1.087 0-1.556.015-.618.015-.97.015-1.134 0 .485.008 1.885.117-.39.21-4.294 3.638-7.898 7.852-8.508.808-.117 1.64-.18 2.464-.18h120.99c5.263 0 8.8 2.518 10.067 7.249.28 1.032.366 2.134.366 3.198.023 34.507.023 59.599.015 94.106 0 5.138-2.433 8.563-7.23 10.009-1.041.313-2.192.383-3.296.399z",
  fill: "#E6E6E6"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 100,
  y: 39,
  width: 53,
  height: 44,
  rx: 8.13,
  transform: "rotate(90 100 39)",
  stroke: "url(#partner-portal_svg__a)",
  strokeWidth: 4
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 95.529,
  y: 43.373,
  width: 44.167,
  height: 35,
  rx: 4.127,
  transform: "rotate(90 95.53 43.373)",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 90.775,
  y: 52,
  width: 4,
  height: 26,
  rx: 2,
  transform: "rotate(90 90.775 52)",
  fill: "url(#partner-portal_svg__b)"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 82,
  y: 59,
  width: 4,
  height: 17,
  rx: 2,
  transform: "rotate(90 82 59)",
  fill: "url(#partner-portal_svg__c)"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 51.529,
  y: 43.373,
  width: 44.167,
  height: 35,
  rx: 4.127,
  transform: "rotate(90 51.53 43.373)",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 46.775,
  y: 52,
  width: 4,
  height: 26,
  rx: 2,
  transform: "rotate(90 46.775 52)",
  fill: "url(#partner-portal_svg__d)"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 38,
  y: 59,
  width: 4,
  height: 17,
  rx: 2,
  transform: "rotate(90 38 59)",
  fill: "url(#partner-portal_svg__e)"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 95.529,
  y: 98,
  width: 44.167,
  height: 35,
  rx: 4.127,
  transform: "rotate(90 95.53 98)",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 90.775,
  y: 107,
  width: 4,
  height: 26,
  rx: 2,
  transform: "rotate(90 90.775 107)",
  fill: "url(#partner-portal_svg__f)"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 82,
  y: 114,
  width: 4,
  height: 17,
  rx: 2,
  transform: "rotate(90 82 114)",
  fill: "url(#partner-portal_svg__g)"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 51.529,
  y: 97.54,
  width: 44.167,
  height: 35,
  rx: 4.127,
  transform: "rotate(90 51.53 97.54)",
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 46.775,
  y: 106,
  width: 4,
  height: 26,
  rx: 2,
  transform: "rotate(90 46.775 106)",
  fill: "url(#partner-portal_svg__h)"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 38,
  y: 113,
  width: 4,
  height: 17,
  rx: 2,
  transform: "rotate(90 38 113)",
  fill: "url(#partner-portal_svg__i)"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 138.529,
  y: 98,
  width: 44.167,
  height: 35,
  rx: 4.127,
  transform: "rotate(90 138.529 98)",
  fill: "#fff"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 139.529,
  y: 43.373,
  width: 44.167,
  height: 35,
  rx: 4.127,
  transform: "rotate(90 139.529 43.373)",
  fill: "#858585"
});

var _ref17 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#partner-portal_svg__j)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 208.886,
  y: 35.54,
  width: 128.647,
  height: 101.946,
  rx: 4.127,
  transform: "rotate(108 208.886 35.54)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M173.734 117.418a2 2 0 00-1.284-2.52l-77.987-25.34a2 2 0 00-1.236 3.804l77.987 25.34a2.001 2.001 0 002.52-1.284zM186.355 72.1a1.999 1.999 0 11-1.236 3.804l-77.986-25.34a1.999 1.999 0 111.236-3.803l77.986 25.34zm2.782-8.56a2 2 0 01-1.237 3.805l-20.923-6.799a2 2 0 011.236-3.804l20.924 6.799zm4.065-6.039a2 2 0 00-1.284-2.52l-48.504-15.76a2 2 0 10-1.236 3.804l48.504 15.76a2 2 0 002.52-1.284zm-57.064-18.54a1.999 1.999 0 00-1.284-2.52l-20.923-6.8a2 2 0 00-1.236 3.805l20.923 6.798a2 2 0 002.52-1.284zm24.8 17.52a2 2 0 00-1.284-2.52l-48.504-15.76a2 2 0 10-1.236 3.804l48.504 15.76a2 2 0 002.52-1.284zm23.92 26.699a1.999 1.999 0 00-1.284-2.52l-29.483-9.58a2 2 0 00-1.236 3.804l29.483 9.58a2 2 0 002.52-1.284zm-39.326-14.881a2 2 0 01-1.236 3.804l-39.945-12.978a2 2 0 011.237-3.805l39.944 12.98zm36.545 23.44a2 2 0 00-1.284-2.52l-48.504-15.76a2 2 0 00-1.236 3.804l48.504 15.76a2 2 0 002.52-1.284zM123.73 70.68a2 2 0 01-1.236 3.803l-20.924-6.798a2 2 0 011.236-3.804l20.924 6.798zm55.566 29.62a2 2 0 00-1.284-2.52l-20.923-6.799a2 2 0 10-1.236 3.804l20.923 6.799a2 2 0 002.52-1.284zm-30.767-12.1a1.999 1.999 0 11-1.236 3.804l-48.504-15.76a2 2 0 011.236-3.804l48.504 15.76zm21.139 35.258a1.999 1.999 0 11-1.236 3.804l-29.482-9.579a2 2 0 111.236-3.804l29.482 9.579zm-36.758-9.84a2 2 0 00-1.284-2.521L91.682 98.118a2 2 0 00-1.236 3.804l39.944 12.979a2 2 0 002.52-1.284zm33.977 18.4a2 2 0 01-1.236 3.804l-48.504-15.76a2 2 0 011.236-3.804l48.504 15.76zm-55.779-16.021a2 2 0 00-1.284-2.52l-20.923-6.799a2 2 0 00-1.236 3.804l20.923 6.799a2 2 0 002.52-1.284zm52.998 24.58a1.999 1.999 0 11-1.236 3.804l-20.923-6.798a1.999 1.999 0 111.236-3.804l20.923 6.798zm-28.199-7.059a1.999 1.999 0 00-1.284-2.52l-48.503-15.76a2 2 0 10-1.237 3.804l48.504 15.76a2 2 0 002.52-1.284z",
  fill: "url(#partner-portal_svg__k)"
}));

var _ref18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "partner-portal_svg__a",
  x1: 102.316,
  y1: 32.447,
  x2: 156.501,
  y2: 36.529,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#39F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#63C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "partner-portal_svg__b",
  x1: 94.827,
  y1: 47.397,
  x2: 86.618,
  y2: 48.625,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F5F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EEE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "partner-portal_svg__c",
  x1: 86.052,
  y1: 55.99,
  x2: 78.077,
  y2: 57.815,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F5F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EEE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "partner-portal_svg__d",
  x1: 50.827,
  y1: 47.397,
  x2: 42.618,
  y2: 48.625,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F5F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EEE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "partner-portal_svg__e",
  x1: 42.052,
  y1: 55.99,
  x2: 34.077,
  y2: 57.815,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F5F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EEE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "partner-portal_svg__f",
  x1: 94.827,
  y1: 102.397,
  x2: 86.618,
  y2: 103.625,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F5F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EEE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "partner-portal_svg__g",
  x1: 86.052,
  y1: 110.99,
  x2: 78.077,
  y2: 112.815,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F5F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EEE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "partner-portal_svg__h",
  x1: 50.827,
  y1: 101.397,
  x2: 42.618,
  y2: 102.625,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F5F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EEE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "partner-portal_svg__i",
  x1: 42.052,
  y1: 109.99,
  x2: 34.077,
  y2: 111.815,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F5F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EEE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "partner-portal_svg__k",
  x1: 138.374,
  y1: 137.373,
  x2: 123.374,
  y2: 36.373,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F5F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EEE"
})), /*#__PURE__*/React.createElement("filter", {
  id: "partner-portal_svg__j",
  x: 67.176,
  y: -0.963,
  width: 146.711,
  height: 163.853,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_153_1899"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_153_1899",
  result: "shape"
})));

function SvgPartnerPortal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 162,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

export default "data:image/svg+xml;base64,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";
export { SvgPartnerPortal as ReactComponent };